// Prepends a null-value option to a <Form.Select>'s options, using the same
// text as the field's placeholder, so the empty state is also selectable
// from the list itself (not only via the `clearable` "x").
export function withEmptyOption(options = [], text) {
  return [{ key: "empty", value: null, text }, ...options];
}
